/**
 * Product Mobile Carousel - Laoli Theme
 * Handles mobile carousel functionality using Owl Carousel
 */

function initPdpMobileCarousel() {
  const mobileCarousel = document.querySelector('.laoli-pdp-mobile-carousel');
  
  if (!mobileCarousel) {
    return;
  }

  // Mobile carousel
  if (mobileCarousel && typeof $ !== 'undefined' && $.fn && $.fn.owlCarousel) {
    try {
      $(mobileCarousel).owlCarousel({
        margin: 15,
        autoWidth: true,
        dots: true,
        center: true,
        smartSpeed: 500,
        animateIn: 'ease-out',
        animateOut: 'ease-out'
      });
    } catch (error) {
      
    }
  } else {
    
  }
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdpMobileCarousel };
}
